/* gummy-counter.js — Bold Maker
   Deterministic, time-based count-up. Same value for every visitor,
   climbs in real time. Pairs with sections/gummy-counter.liquid.

   Loaded as a standalone asset (not inline) so it survives Concept's
   Section Rendering API re-renders. init is idempotent. */
(function () {
  'use strict';

  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function format(n) {
    return Math.floor(n).toLocaleString('en-US');
  }

  function startCounter(el) {
    if (el.dataset.gummyInit === 'true') return;
    el.dataset.gummyInit = 'true';

    var anchorMs = parseFloat(el.dataset.anchorMs);
    var anchorCount = parseFloat(el.dataset.anchorCount);
    var rate = parseFloat(el.dataset.rate);
    var animate = el.dataset.animate === 'true';
    var numberEl = el.querySelector('[data-gummy-number]');

    if (!numberEl || isNaN(anchorMs) || isNaN(anchorCount) || isNaN(rate)) {
      return;
    }

    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function liveValue() {
      return anchorCount + ((Date.now() - anchorMs) / 1000) * rate;
    }

    function tickForever() {
      var last = null;
      function frame() {
        var v = Math.floor(liveValue());
        if (v !== last) {
          last = v;
          numberEl.textContent = v.toLocaleString('en-US');
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    // No intro animation: jump to the live value and keep ticking.
    if (!animate || prefersReduced) {
      numberEl.textContent = format(liveValue());
      tickForever();
      return;
    }

    // Intro: sweep 0 -> current value, then hand off to the live ticker.
    var target = liveValue();
    var duration = 1800;
    var begin = null;

    function intro(ts) {
      if (begin === null) begin = ts;
      var p = Math.min(1, (ts - begin) / duration);
      var v = Math.floor(target * easeOutExpo(p));
      numberEl.textContent = v.toLocaleString('en-US');
      if (p < 1) {
        requestAnimationFrame(intro);
      } else {
        tickForever();
      }
    }
    requestAnimationFrame(intro);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-gummy-counter]');
    for (var i = 0; i < els.length; i++) {
      startCounter(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }

  // Re-init when added/updated via the theme editor.
  document.addEventListener('shopify:section:load', initCounters);
})();
